import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ffbc3ed"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "CreateList_operationWrapper" }
const _hoisted_2 = { class: "paging_container" }
const _hoisted_3 = { class: "CreateList_BtnBlock" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"display":"inline-block"} }, "＋新規作成", -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "CreateList_TableContainer" }
const _hoisted_7 = { class: "CreateList_Table" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "参照"),
    /*#__PURE__*/_createElementVNode("th", null, "画像"),
    /*#__PURE__*/_createElementVNode("th", null, "添付ファイル"),
    /*#__PURE__*/_createElementVNode("th", null, [
      /*#__PURE__*/_createTextVNode("リスト名"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("説明")
    ]),
    /*#__PURE__*/_createElementVNode("th", null, "表示期間"),
    /*#__PURE__*/_createElementVNode("th", null, "登録日"),
    /*#__PURE__*/_createElementVNode("th", null, "登録者"),
    /*#__PURE__*/_createElementVNode("th", null, "削除")
  ])
], -1))
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "img_td" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { key: 2 }
const _hoisted_13 = ["onClick", "disabled"]
const _hoisted_14 = {
  key: 1,
  class: "loading"
}
const _hoisted_15 = { style: {"min-width":"200px","text-align":"left"} }
const _hoisted_16 = { style: {"border-bottom":"1px solid #afafaf"} }
const _hoisted_17 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_18 = { key: 1 }
const _hoisted_19 = {
  key: 0,
  class: "ResultMessageNull"
}

import PankuzuHeader from "../components/PankuzuHeader.vue";
import { nextTick, ref } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { Notyf } from "notyf";
import axios from "axios";
import ModalWarningMessage from "@/components/modal/ModalWarningMessage.vue";
import mediumZoom from "medium-zoom";
import Paginate from "vuejs-paginate-next";
import OrderHeader from "@/components/OrderHeader.vue";

type Lists = typeof search_result.value[0];


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateList',
  props: {
  isActive_SidebarFlg: { type: Boolean },
},
  setup(__props) {

const notyf = new Notyf();
const router = useRouter();
const store = useStore();
const props = __props;
// ストアの初期化------------------------------------------------
store.commit("search/clearAuthData");

//ぱんくずヘッダー
const currentPathList = [{ name: "受注入力" }, { name: "注文リスト作成" }];
//検索ヘッダ関連----------------------------------------------
let isActiveKaniFlg = ref<boolean>(false);
let isActive_SyosaiFlg = ref<boolean>(true);
let isOpentoggleArea = ref<boolean>(true);
const changeKaniFlg = (KaniFlg: boolean): void => {
  isActiveKaniFlg.value = KaniFlg;
};
const changeSyosaiFlg = (SyosaiFlg: boolean): void => {
  isActive_SyosaiFlg.value = SyosaiFlg;
};

const changeToggleArea = (toggleAreaFlg: boolean): void => {
  isOpentoggleArea.value = toggleAreaFlg;
};
let searchAreaToggle: boolean = true;

// データ取得----------------------------------------------------
// 1ページあたりの表示データ数(一旦固定)
let dataPerPage = 20;
const search_result = ref([
  {
    hanmotoCd: null as string | null,
    userId: null as string | null,
    userName: "",
    listId: -1,
    imageUrl: "",
    listName: "",
    description: "",
    registerDate: "",
    startDate: "" as string | null,
    endDate: "" as string | null,
    syosiList: null,
    expired: false,
    attatchedFileName: null as string | null,
  },
]);
const getData = async () => {
  const searchConditions = store.getters["search/getCreateListState"];
  try {
    const res = await axios.get(
      `${store.getters["getBaseUrl"]}/compile/list-display?freeword=${store.getters["search/getSearchSimpleState"]}&syosiCd=${searchConditions.syosiCd}&userId=${store.getters["login/getUserData"].userId}&fromRegisterDate=${searchConditions.fromRegisterDate}&toRegisterDate=${searchConditions.toRegisterDate}&fromDisplayDate=${searchConditions.fromDisplayDate}&toDisplayDate=${searchConditions.toDisplayDate}&containsMukigen=${searchConditions.containsMukigen}&shouldDisplayExpired=${searchConditions.isExpired}&page=${store.getters["search/getPageNumber"]}&numberOfDisplay=${dataPerPage}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      }
    );
    numberOfTotalData.value = res.data.size;
    firstCount.value = res.data.firstCount;
    finalCount.value = res.data.finalCount;
    search_result.value.splice(0);
    search_result.value = res.data.compiledSyosiList;
    getTotalPage();
    await nextTick();
    mediumZoom(document.querySelectorAll("img"), {
      background: "#696969",
      scrollOffset: 100,
      container: {
        top: 30,
        bottom: 30,
      },
    });
  } catch (error) {
    console.log(error);
    alert("リストデータを取得できませんでした");
  }
};
getData();

// 検索
const onSearch = async () => {
  currentPage.value = 1;
  store.commit("search/setPageNumber", currentPage.value);
  await getData();
};

// 日付を表示用に変換--------------------------------------------
const convertDate = (date: string | null) => {
  if (typeof date === "string") {
    const targetDate = new Date(date);
    const year = targetDate.getFullYear();
    const month = targetDate.getMonth() + 1;
    const day = targetDate.getDate();
    return year + "/" + month + "/" + day;
  } else {
    return null;
  }
};

// ページネーション関連処理-----------------------------------------
// 取得データ合計
let numberOfTotalData = ref(0);
//表示中のページ範囲
let firstCount = ref(0);
let finalCount = ref(0);
// 総ページ数
const numberOfTotalPage = ref(0);
// 現在のページ数
const currentPage = ref(1);
const getTotalPage = () => {
  numberOfTotalPage.value = Math.ceil(numberOfTotalData.value / dataPerPage);
};
const onClickPage = (newPage: number) => {
  currentPage.value = newPage;
  store.commit("search/setPageNumber", currentPage.value);
  getData();
};

// リスト削除----------------------------------------------------
let deleteIndex = -1;
const deleteList = (list: Lists) => {
  warningModalVisible.value = true;
  deleteIndex = list.listId;
  warningMessage.value = `「${list.listName}」のリストを削除してもよろしいですか？`;
};
// 削除確認モーダル
const warningModalVisible = ref(false);
const warningMessage = ref("");
const excuteDelete = async () => {
  warningModalVisible.value = false;
  try {
    await axios.delete(
      `${store.getters["getBaseUrl"]}/compile/delete?listId=${deleteIndex}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      }
    );
    notyf.success("リストを削除しました");
    getData();
  } catch (error) {
    console.log(error);
    alert("リストの削除に失敗しました");
  }
};
// 添付ファイル関連----------------------------------------------
// ダウンロード
const isAttachedDownloading = ref({
  index: -1,
  isDownloading: false,
});
const getAttachedFile = async (index: number) => {
  isAttachedDownloading.value.isDownloading = true;
  isAttachedDownloading.value.index = index;
  try {
    const res = await axios.get(
      `${store.getters["getBaseUrl"]}/compile/attached-file-download?syosiListId=${search_result.value[index].listId}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
        responseType: "arraybuffer",
        responseEncoding: "binary",
      }
    );
    downloadAttachedFile(index, res);
  } catch (error) {
    isAttachedDownloading.value.isDownloading = false;
    notyf.error("ダウンロードに失敗しました");
    console.log(error);
  }
};
const downloadAttachedFile = (index: number, resData: any) => {
  let blob = new Blob([resData.data], {
    type: resData.headers["content-type"],
  });
  let link = document.createElement("a");
  link.href = window.URL.createObjectURL(blob);
  link.download = search_result.value[index].attatchedFileName as string;
  link.click();
  isAttachedDownloading.value.isDownloading = false;
};
// 参照ページ表示---------------------------------------------
const transToDetail = (listId: number) => {
  router.push({
    name: "CreateNewList",
    params: { id: listId },
  });
};

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["CreateList", {
      SideBar_False: !props.isActive_SidebarFlg,
      SideBar_True: props.isActive_SidebarFlg,
    }])
  }, [
    _createVNode(PankuzuHeader, {
      isActive_SidebarFlg: props.isActive_SidebarFlg,
      currentPathList: currentPathList
    }, null, 8, ["isActive_SidebarFlg"]),
    _createVNode(OrderHeader, {
      isActiveKaniFlg: _unref(isActiveKaniFlg),
      isActive_SyosaiFlg: _unref(isActive_SyosaiFlg),
      isActive_SidebarFlg: __props.isActive_SidebarFlg,
      searchAreaToggle: _unref(searchAreaToggle),
      searchType: "createList",
      onChangeKaniFlg: changeKaniFlg,
      onChangeSyosaiFlg: changeSyosaiFlg,
      onChangeToggleArea: changeToggleArea,
      onOnSearch: onSearch
    }, null, 8, ["isActiveKaniFlg", "isActive_SyosaiFlg", "isActive_SidebarFlg", "searchAreaToggle"]),
    (warningModalVisible.value)
      ? (_openBlock(), _createBlock(ModalWarningMessage, {
          key: 0,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (warningModalVisible.value = false)),
          onExecute: excuteDelete,
          message: warningMessage.value
        }, null, 8, ["message"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(Paginate), {
          "page-count": numberOfTotalPage.value,
          "hide-prev-next": true,
          "page-range": 3,
          "prev-text": '<',
          "next-text": '>',
          "container-class": 'pagination',
          "page-class": 'page-item',
          "page-link-class": 'page-item--link',
          "active-class": 'page-item--active',
          "click-handler": onClickPage,
          "force-page": currentPage.value
        }, null, 8, ["page-count", "force-page"]),
        _withDirectives(_createElementVNode("span", { class: "paging_result" }, " 検索結果：" + _toDisplayString(_unref(numberOfTotalData)) + "件/" + _toDisplayString(_unref(firstCount)) + "～" + _toDisplayString(_unref(finalCount)) + "件を表示", 513), [
          [_vShow, search_result.value.length]
        ])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).push('/createNewList/-1'))),
          class: "CreateList_BtnGreen"
        }, _hoisted_5)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("table", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(search_result.value, (result, index) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: index,
              class: _normalizeClass({ bg_gray: result.expired })
            }, [
              _createElementVNode("td", null, [
                _createElementVNode("button", {
                  onClick: ($event: any) => (transToDetail(result.listId)),
                  class: "CreateList_Table_Button"
                }, " 照会 ", 8, _hoisted_9)
              ]),
              _createElementVNode("td", _hoisted_10, [
                (result.imageUrl === null)
                  ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                      key: 0,
                      icon: "image",
                      class: "img_icon"
                    }))
                  : (index <= 3)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        src: 
                  result.imageUrl.includes('juchu-connect')
                    ? result.imageUrl
                    : `data:image;base64,${result.imageUrl}`
                
                      }, null, 8, _hoisted_11))
                    : _withDirectives((_openBlock(), _createElementBlock("img", _hoisted_12, null, 512)), [
                        [_directive_lazy, 
                  result.imageUrl.includes('juchu-connect')
                    ? result.imageUrl
                    : `data:image;base64,${result.imageUrl}`
                ]
                      ])
              ]),
              _createElementVNode("td", null, [
                _createTextVNode(_toDisplayString(result.attatchedFileName) + " ", 1),
                (result.attatchedFileName !== null)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      onClick: ($event: any) => (getAttachedFile(index)),
                      class: _normalizeClass(["CreateList_BtnGreen file_download_btn", {
                  disabled_btn:
                    isAttachedDownloading.value.index === index &&
                    isAttachedDownloading.value.isDownloading,
                }]),
                      disabled: 
                  isAttachedDownloading.value.index === index &&
                  isAttachedDownloading.value.isDownloading
                
                    }, [
                      (
                    !(
                      isAttachedDownloading.value.index === index &&
                      isAttachedDownloading.value.isDownloading
                    )
                  )
                        ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                            key: 0,
                            icon: "download",
                            style: {"display":"inline-block"}
                          }))
                        : _createCommentVNode("", true),
                      (
                    isAttachedDownloading.value.index === index &&
                    isAttachedDownloading.value.isDownloading
                  )
                        ? (_openBlock(), _createElementBlock("span", _hoisted_14))
                        : _createCommentVNode("", true),
                      _createTextVNode(" ダウンロード ")
                    ], 10, _hoisted_13))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("td", _hoisted_15, [
                _createElementVNode("p", _hoisted_16, _toDisplayString(result.listName), 1),
                _createElementVNode("p", null, _toDisplayString(result.description), 1)
              ]),
              _createElementVNode("td", null, [
                (
                  result.startDate === null && result.endDate === '9999-12-31'
                )
                  ? (_openBlock(), _createElementBlock("span", _hoisted_17, "無期限"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(convertDate(result.startDate)) + "～" + _toDisplayString(convertDate(result.endDate)), 1))
              ]),
              _createElementVNode("td", null, _toDisplayString(convertDate(result.registerDate)), 1),
              _createElementVNode("td", null, _toDisplayString(result.userName), 1),
              _createElementVNode("td", null, [
                _createVNode(_component_font_awesome_icon, {
                  onClick: ($event: any) => (deleteList(result)),
                  class: "CreateList_Table_Icon",
                  icon: "trash-can"
                }, null, 8, ["onClick"])
              ])
            ], 2))
          }), 128))
        ])
      ]),
      (!search_result.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, " ※作成されたリストはありません "))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})